export default "__VITE_ASSET__CxVZPXZD__"